import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Button, Tab, Tabs } from "@mui/material";
import React, { useState, useEffect } from "react";
import RejectReasonModal from "../../Modals/rejectReason";
import PropertyList from "../../features/manageCustomers/propertyList";
import {
  useLazyGetWorkQuery,
  useLazyGetWorkIdQuery,
} from "../../services/users";
import { showError } from "../../constants/toasts";
import moment from "moment";
import { SKILLS } from "../../utils/enums";
import Loader from "../../constants/Loader";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ViewWorkHistory = () => {
  const navigate = useNavigate();
  const { workId, freelancerId } = useParams();
  const [getWork] = useLazyGetWorkIdQuery();
  const [workData, setWorkData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchWorkDetails = async () => {
    if (!workId) return;
    setIsLoading(true);
    try {
      const response = await getWork({ id: workId }).unwrap();
      if (response?.statusCode === 200) {
        setWorkData(response.data || null);
      } else {
        setWorkData(null);
      }
    } catch (error) {
      showError("Failed to load work details");
      setWorkData(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchWorkDetails();
  }, [workId]);

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <>
      <MainContainer>
        <Loader isLoad={isLoading} />
        <div className="main_title">
          <h1>Work History Detail</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/manage-freelancer")}>
              Manage Freelancer
            </span>
            -{" "}
            <span onClick={() => navigate(`/manage-freelancer/detail/${freelancerId}`)}>
              Freelancer Detail
            </span>{" "}
            - Work History Detail
          </p>
        </div>

        <div className="cards view_page">
          <div className="section_title">
            <h2>Work History Details</h2>
          </div>
          {workData ? (
            <div className="gap_p">
              <div className="w_33">
                <h6>Category</h6>
                <p>{workData.category?.name || "-"}</p>
              </div>
              <div className="w_33">
                <h6>Sub Category</h6>
                <p>{workData.subCategory?.name || "-"}</p>
              </div>
              <div className="w_33">
                <h6>Services</h6>
                <p>{workData.serviceNames?.join(", ") || "-"}</p>
              </div>
              <div className="w_33">
                <h6>Sub Total</h6>
                <p>AED {workData.subTotal || "0"}</p>
              </div>
              <div className="w_33">
                <h6>Total</h6>
                <p>AED {workData.total || "0"}</p>
              </div>
              <div className="w_33">
                <h6>Created At</h6>
                <p>
                  {moment(workData.createdAt).format("DD MMM YYYY, hh:mm A")}
                </p>
              </div>
              <div className="w_33">
                <h6>Start Time</h6>
                <p>
                  {moment(workData.startTime).format("DD MMM YYYY, hh:mm A")}
                </p>
              </div>
              <div className="w_33">
                <h6>End Time</h6>
                <p>{moment(workData.endTime).format("DD MMM YYYY, hh:mm A")}</p>
              </div>
              <div className="w_33">
                <h6>Skills</h6>
                <p>
                  {Array.isArray(workData.skills)
                    ? workData.skills
                        .map((skillId: string) =>
                          Object.keys(SKILLS).find(
                            (key) =>
                              SKILLS[key as keyof typeof SKILLS] ===
                              Number(skillId)
                          )
                        )
                        .join(", ")
                    : "-"}
                </p>
              </div>
              <div className="w_100">
                <h6>Notes</h6>
                <p>{workData.notes || "-"}</p>
              </div>
              {workData.media && workData.media.length > 0 && (
                <div className="w_100">
                  <h6>Media</h6>
                  <div className="gap_p">
                    {workData.media.map((item: string, index: number) => {
                      const isVideo = item
                        .toLowerCase()
                        .match(/\.(mp4|webm|ogg)$/);
                      return (
                        <div key={index} className="w_33">
                          <figure className="passport_img">
                            {isVideo ? (
                              <video src={item} controls />
                            ) : (
                              <img
                                src={item || "/static/images/placeholder.png"}
                                alt="Media"
                              />
                            )}
                          </figure>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div>No work history details found</div>
          )}
        </div>
      </MainContainer>

      <RejectReasonModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
      />
    </>
  );
};

export default ViewWorkHistory;
